import Why from "./Why";

export default Why;
